// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","primary":"Button_primary__XYgy-","outlined":"Button_outlined__gq+aU","plainText":"Button_plainText__1mkpZ"};